import {
  startOfWeek,
  addDays,
  subWeeks,
  isWithinInterval,
  differenceInHours,
  endOfDay,
  startOfMinute,
} from 'date-fns';

export const calculateNoteSubmissionRate = (sessions: any[]) => {
  const now = new Date();
  const weeks: {
    week: string;
    start: Date;
    end: Date;
    total: number;
    timely: number;
  }[] = [];

  for (let i = 11; i >= 0; i--) {
    const start = startOfWeek(subWeeks(now, i), {weekStartsOn: 0});
    const end = addDays(start, 7);
    weeks.push({
      week: start.toISOString().split('T')[0],
      start,
      end,
      total: 0,
      timely: 0,
    });
  }

  for (const session of sessions) {
    const {editedEndTimestamp, submissionTimestamp} = session;
    const end = new Date(editedEndTimestamp);
    const sessionEndOfDay = endOfDay(end);

    for (const week of weeks) {
      if (isWithinInterval(end, {start: week.start, end: week.end})) {
        week.total += 1;
        const noteSubmittedAt = startOfMinute(new Date(submissionTimestamp));
        if (differenceInHours(noteSubmittedAt, sessionEndOfDay) <= 48) {
          week.timely += 1;
        }
        break;
      }
    }
  }

  return weeks.map(({week, total, timely}) => {
    const percentage = total > 0 ? (timely / total) * 100 : 0;
    return {
      week,
      percentage: Math.abs(percentage) < 0.01 ? 0 : percentage,
      total,
      timely,
    };
  });
};
